import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import {
  DangerButton,
  InfoButton,
  SuccessButton,
  WarningButton,
} from "../../../../ui/buttons/Button";
import { Input, SearchInput, Textarea } from "../../../../ui/inputs/Input";
import { Dimmer } from "../../../spinner";
import { Mensaje, MensajeSiNo } from "../../../mensajes2";
import axios from "axios";
import {
  formatMoneda,
  seleccionarCampo,
  validaMonto,
  validaSoloNumero,
} from "../../../../util/varios";
import moment from "moment";
import CatalogoTipoActivos from "../../../../catalogos/catalogoTipoActivos";
import CatalogoOrdenPago from "../../../../catalogos/catalogoOrdenPago";
import CatalogoProveedores from "../../../../catalogos/catalogoProveedores";
import CatalogoUbicacionBien from "../../../../catalogos/catalogoUbicacionBien";
import CatalogoMotivoIncorporacion from "../../../../catalogos/catalogoMotivoIncorporacion";
import CatalogoIncorporacionMueble from "../../../../catalogos/catalogoIncorporacionMueble";
const op = require("../../../../modulos/datos");

export default function IncorporacionBienesMuebles({
  show,
  setShow,
  setTabla,
}) {
  const token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));

  const btnCancela = useRef();
  const btnAcepta = useRef();

  const btnTab1 = useRef();
  const btnTab2 = useRef();
  const btnTab3 = useRef();

  const txtCodigo = useRef();
  const txtCodActivo = useRef();
  const txtDescripcionActivo = useRef();
  const txtTipoMaterial = useRef();
  const txtFecha = useRef();
  const txtCodOrden = useRef();
  const txtNumFactura = useRef();
  const txtFechaAdquisicion = useRef();
  const txtCodProveedor = useRef();
  const txtRif = useRef();
  const txtNombre = useRef();
  const txtIdUbicacion = useRef();
  const txtCodigoUbicacion = useRef();
  const txtDescripcionUbicacion = useRef();
  const txtOriginal = useRef();
  const txtMas = useRef();
  const txtMenos = useRef();
  const txtActual = useRef();
  const txtCodigoBien = useRef();
  const txtCodigoBienNacional = useRef();
  const txtMarca = useRef();
  const txtModelo = useRef();
  const txtAnio = useRef();
  const txtColor = useRef();
  const txtCapacidad = useRef();
  const txtTipo = useRef();
  const txtSeriales = useRef();
  const txtNumPieza = useRef();
  const txtPlaca = useRef();
  const txtUso = useRef();
  const txtAlto = useRef();
  const txtLargo = useRef();
  const txtAncho = useRef();
  const txtObservacion = useRef();
  const txtCedula = useRef();
  const txtNombreResponsa = useRef();
  const txtCodMotivo = useRef();
  const txtDescripcionMotivo = useRef();
  const txtValorInicial = useRef();
  const txtValorRescate = useRef();
  const txtDepresiacionMensual = useRef();
  const txtDepresiacionAcumulada = useRef();
  const txtValorLibros = useRef();
  const txtValorAdicion = useRef();
  const txtValorReexpresado = useRef();
  const txtCostoReposicion = useRef();

  const estilos = {
    tab: {
      borderBottomLeftRadius: 0.25,
      borderBottomRightRadius: 0.25,
      border: "solid rgba(5, 81, 130, 0.5)",
      borderBottom: "none",
    },
    contenido: {
      border: "solid rgba(5, 81, 130, 0.5)",
    },
  };

  const [tab, setTab] = useState(1);
  const [operacion, setOperacion] = useState(0);
  const [txtOperacion, setTxtOperacion] = useState("");
  const [activate, setActivate] = useState(false);
  const [visibleButton, setVisibleButton] = useState(true);
  const [disabledPrint, setDisabledPrint] = useState(true);
  const [disabledCode, setDisabledCode] = useState(true);
  const [mostrarCatalogoTipo, setMostrarCatalogoTipo] = useState(false);
  const [mostrarCatalogoOrden, setMostrarCatalogoOrden] = useState(false);
  const [mostrarCatalogoProveedor, setMostrarCatalogoProveedor] =
    useState(false);
  const [mostrarCatalogoUbicacion, setMostrarCatalogoUbicacion] =
    useState(false);
  const [mostrarCatalogoMotivo, setMostrarCatalogoMotivo] = useState(false);
  const [mostrarCatalogoIncorp, setMostrarCatalogoIncorp] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [generaAsiento, setGeneraAsiento] = useState(false);
  const [idAsiAnt, setIdAsiAnt] = useState(0);
  const [idClaseBien, setIdClaseBien] = useState(0);

  const onChange = (e) => {
    if (e.target.value !== "") {
      e.target.value = e.target.value.toUpperCase();
    }
  };

  const onNextChange = (e) => {
    if (e.which === 13) {
      if (e.target.name === "codigoactivo") {
        txtDescripcionActivo.current.focus();
      } else if (e.target.name === "tipomaterial") {
        btnAcepta.current.focus();
      }
    }
  };

  const habilitarCampos = () => {
    txtCodActivo.current.disabled = false;
    txtFecha.current.disabled = false;
    txtCodOrden.current.disabled = false;
    txtNumFactura.current.disabled = false;
    txtFechaAdquisicion.current.disabled = false;
    txtCodProveedor.current.disabled = false;
    txtIdUbicacion.current.disabled = false;
    txtOriginal.current.disabled = false;
    txtMas.current.disabled = false;
    txtMenos.current.disabled = false;
    txtCodigoBien.current.disabled = false;
    txtCodigoBienNacional.current.disabled = false;
    txtMarca.current.disabled = false;
    txtModelo.current.disabled = false;
    txtAnio.current.disabled = false;
    txtColor.current.disabled = false;
    txtCapacidad.current.disabled = false;
    txtTipo.current.disabled = false;
    txtSeriales.current.disabled = false;
    txtNumPieza.current.disabled = false;
    txtPlaca.current.disabled = false;
    txtUso.current.disabled = false;
    txtAlto.current.disabled = false;
    txtLargo.current.disabled = false;
    txtAncho.current.disabled = false;
    txtObservacion.current.disabled = false;
    txtCodMotivo.current.disabled = false;
    txtValorInicial.current.disabled = false;
    txtValorRescate.current.disabled = false;
    txtDepresiacionMensual.current.disabled = false;
    txtDepresiacionAcumulada.current.disabled = false;
    txtValorLibros.current.disabled = false;
    txtValorAdicion.current.disabled = false;
    txtValorReexpresado.current.disabled = false;
    txtCostoReposicion.current.disabled = false;
  };

  const deshabilitarCampos = () => {
    btnTab1.current.disabled = true;
    btnTab2.current.disabled = true;
    btnTab3.current.disabled = true;
    txtCodigo.current.disabled = true;
    txtCodActivo.current.disabled = true;
    txtFecha.current.disabled = true;
    txtDescripcionActivo.current.disabled = true;
    txtTipoMaterial.current.disabled = true;
    txtCodOrden.current.disabled = true;
    txtNumFactura.current.disabled = true;
    txtFechaAdquisicion.current.disabled = true;
    txtCodProveedor.current.disabled = true;
    txtRif.current.disabled = true;
    txtNombre.current.disabled = true;
    txtIdUbicacion.current.disabled = true;
    txtCodigoUbicacion.current.disabled = true;
    txtDescripcionUbicacion.current.disabled = true;
    txtOriginal.current.disabled = true;
    txtMas.current.disabled = true;
    txtMenos.current.disabled = true;
    txtActual.current.disabled = true;
    txtCodigoBien.current.disabled = true;
    txtCodigoBienNacional.current.disabled = true;
    txtMarca.current.disabled = true;
    txtModelo.current.disabled = true;
    txtAnio.current.disabled = true;
    txtColor.current.disabled = true;
    txtCapacidad.current.disabled = true;
    txtTipo.current.disabled = true;
    txtSeriales.current.disabled = true;
    txtNumPieza.current.disabled = true;
    txtPlaca.current.disabled = true;
    txtUso.current.disabled = true;
    txtAlto.current.disabled = true;
    txtLargo.current.disabled = true;
    txtAncho.current.disabled = true;
    txtObservacion.current.disabled = true;
    txtCedula.current.disabled = true;
    txtNombreResponsa.current.disabled = true;
    txtCodMotivo.current.disabled = true;
    txtDescripcionMotivo.current.disabled = true;
    txtValorInicial.current.disabled = true;
    txtValorRescate.current.disabled = true;
    txtDepresiacionMensual.current.disabled = true;
    txtDepresiacionAcumulada.current.disabled = true;
    txtValorLibros.current.disabled = true;
    txtValorAdicion.current.disabled = true;
    txtValorReexpresado.current.disabled = true;
    txtCostoReposicion.current.disabled = true;
  };

  const blanquear = () => {
    txtCodigo.current.value = "";
    txtCodActivo.current.value = "";
    txtDescripcionActivo.current.value = "";
    txtTipoMaterial.current.value = "";
    txtFecha.current.value = "";
    txtCodOrden.current.value = "";
    txtNumFactura.current.value = "";
    txtFechaAdquisicion.current.value = "";
    txtCodProveedor.current.value = "";
    txtRif.current.value = "";
    txtNombre.current.value = "";
    txtIdUbicacion.current.value = "";
    txtCodigoUbicacion.current.value = "";
    txtDescripcionUbicacion.current.value = "";
    txtOriginal.current.value = "0";
    txtMas.current.value = "0";
    txtMenos.current.value = "0";
    txtActual.current.value = "0";
    txtCodigoBien.current.value = "";
    txtCodigoBienNacional.current.value = "";
    txtMarca.current.value = "";
    txtModelo.current.value = "";
    txtAnio.current.value = "0";
    txtColor.current.value = "";
    txtCapacidad.current.value = "0";
    txtTipo.current.value = "";
    txtSeriales.current.value = "";
    txtNumPieza.current.value = "0";
    txtPlaca.current.value = "";
    txtUso.current.value = "";
    txtAlto.current.value = "0";
    txtLargo.current.value = "0";
    txtAncho.current.value = "0";
    txtObservacion.current.value = "";
    txtCedula.current.value = "";
    txtNombreResponsa.current.value = "";
    txtCodMotivo.current.value = "";
    txtDescripcionMotivo.current.value = "";
    txtValorInicial.current.value = "0,00";
    txtValorRescate.current.value = "0,00";
    txtDepresiacionMensual.current.value = "0,00";
    txtDepresiacionAcumulada.current.value = "0,00";
    txtValorLibros.current.value = "0,00";
    txtValorAdicion.current.value = "0,00";
    txtValorReexpresado.current.value = "0,00";
    txtCostoReposicion.current.value = "0,00";

    setTab(1);
    setOperacion(0);
    setTxtOperacion("");
    setVisibleButton(true);
    setDisabledPrint(true);
    setDisabledCode(true);
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setMensajesino({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });

    setActivate(false);
    setGeneraAsiento(false);
    setIdAsiAnt(0);
    setIdClaseBien(0);
  };

  const procesarRegistro = async (body) => {
    setActivate(true);
    const endpoint = `${op.conexion}/api/bienes/incorporacionmueble/actualizar`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          let msm = "";
          if (operacion === 1) {
            msm =
              "registro " +
              response.data.incorporacionmueble_act +
              " creado correctamente";
          } else if (operacion === 2) {
            msm =
              "registro " +
              response.data.incorporacionmueble_act +
              " modificado correctamente";
          } else if (operacion === 3) {
            msm =
              "registro " +
              response.data.incorporacionmueble_act +
              " eliminado correctamente";
          }

          const descripcion =
            "Para Registrar Incorporacón de Bien Mueble N°: " +
            response.data.incorporacionmueble_act +
            " y Código del Bien N°: " +
            txtCodigoBien.current.value.toUpperCase();

          let ope = 0;

          if (generaAsiento) {
            if (idAsiAnt !== 0) {
              ope = 2;
            } else {
              ope = 1;
            }
          } else {
            ope = 3;
          }

          const datos = {
            ope: ope,
            idEfi: idefiscal,
            fecIni: moment.utc(txtFecha.current.value).format("YYYY-MM-DD"),
            valorInicial: parseFloat(
              txtValorInicial.current.value
                .replace(/\./g, "")
                .replace(",", "."),
            ),
            idIncorpora: response.data.incorporacionmueble_act,
            codigobien: txtCodigoBien.current.value,
            descripcion: descripcion,
            idClaseBien: idClaseBien === null ? 0 : idClaseBien,
            idAsiAnt: idAsiAnt === null ? 0 : idAsiAnt,
          };

          await crearReversarAsiento({ datos });

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: msm,
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        setActivate(false);
        let mensaje = "";
        if (error.response) {
          mensaje = error?.response?.data?.message;
        } else {
          mensaje = error.toString();
        }

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      });
  };

  const crearReversarAsiento = async (body) => {
    setActivate(true);
    const endpoint = `${op.conexion}/api/bienes/incorporacionmueble/crear_reversar_asiento`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "asiento procesado exitosamente",
              icono: "exito",
            });
          }
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response) {
          mensaje = error?.response?.data?.message;
        } else {
          mensaje = error.toString();
        }

        if (
          mensaje ===
          `duplicate key value violates unique constraint "incorporacionmueble_pkey"`
        ) {
          mensaje = "Ya Existe un inmueble con ese codigo.";
        }

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const formato = (n) => {
    try {
      const numero = parseFloat(n);
      if (isNaN(numero)) return false;
      const formatter = new Intl.NumberFormat("es-ES");
      formatter.format(numero);

      return true;
    } catch (e) {
      return false;
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", "."),
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    if (event.target.value) {
      let e = event.target.value
        .replace(/\D/g, "")
        .replace(/([0-9])([0-9]{2})$/, "$1.$2")
        .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

      return formatMoneda(e);
    } else if (event.target.value === "0") {
      return "0,00";
    } else {
      return "0,00";
    }
  };

  const calcularVidaUtil = (event) => {
    validaSoloNumero(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", "."),
      ) === 0.0
    ) {
      event.target.value = "0";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    if (event.target.value) {
      let value = event.target.value;
      const name = event.target.name;
      let origi = "0";
      let mas = "0";
      let menos = "0";
      let monact = "0";

      if (name === "original") {
        origi = value;
        mas = txtMas.current.value === "" ? "0" : txtMas.current.value;
        menos = txtMenos.current.value === "" ? "0" : txtMenos.current.value;
      } else if (name === "mas") {
        origi =
          txtOriginal.current.value === "" ? "0" : txtOriginal.current.value;
        mas = value;
        menos = txtMenos.current.value === "" ? "0" : txtMenos.current.value;
      } else if (name === "menos") {
        origi =
          txtOriginal.current.value === "" ? "0" : txtOriginal.current.value;
        mas = txtMas.current.value === "" ? "0" : txtMas.current.value;
        menos = value;
      }

      monact = parseInt(origi) + parseInt(mas) - parseInt(menos);

      txtActual.current.value = monact;

      return value;
    } else if (event.target.value === "0") {
      return "0";
    } else {
      return "0";
    }
  };

  const ValidarCampos = () => {
    let valido = true;

    if (operacion !== 1 && txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Código no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      setTab(1);
      txtCodigo.current.focus();
    } else if (txtCodActivo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Código del Activo no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      setTab(1);
      txtCodActivo.current.focus();
    } else if (txtDescripcionActivo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "La Descripción del Activo no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      setTab(1);
      txtCodActivo.current.focus();
    } else if (txtFecha.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Favor Ingrese la Fecha de Incorporación",
        icono: "informacion",
      });
      valido = false;
      setTab(1);
      txtFecha.current.focus();
    } else if (txtFechaAdquisicion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Favor Ingrese la Fecha de Adquisición",
        icono: "informacion",
      });
      valido = false;
      setTab(1);
      txtFechaAdquisicion.current.focus();
    } else if (txtIdUbicacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Código de la Ubicación no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      setTab(1);
      txtIdUbicacion.current.focus();
    } else if (txtCodigoUbicacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "La Descripción de la Ubicación no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      setTab(1);
      txtCodigoUbicacion.current.focus();
    } else if (txtCodigoBien.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Código del Bien no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      setTab(2);
      txtCodigoBien.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "La Cédula del Responsable Patrimonial no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      setTab(2);
      txtCedula.current.focus();
    } else if (txtNombreResponsa.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Nombre del Responsable Patrimonial no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      setTab(2);
      txtNombreResponsa.current.focus();
    } else if (txtCodMotivo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Código del Motivo de Incorporación no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      setTab(2);
      txtCodMotivo.current.focus();
    } else if (txtDescripcionMotivo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "La Descripción del Motivo de Incorporación no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      setTab(2);
      txtDescripcionMotivo.current.focus();
    } else if (txtValorInicial.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Inicial No Puede Estar Vacio.",
        icono: "informacion",
      });
      setTab(3);
      txtValorInicial.current.focus();
      valido = false;
    } else if (!formato(txtValorInicial.current.value)) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Inicial Inválido.",
        icono: "informacion",
      });
      setTab(3);
      txtValorInicial.current.focus();
      valido = false;
    } else if (txtValorRescate.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Rescate No Puede Estar Vacio.",
        icono: "informacion",
      });
      setTab(3);
      txtValorRescate.current.focus();
      valido = false;
    } else if (!formato(txtValorRescate.current.value)) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Rescate Inválido",
        icono: "informacion",
      });
      setTab(3);
      txtValorRescate.current.focus();
      valido = false;
    } else if (txtDepresiacionMensual.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto de la Depresiación Mensual No Puede Estar Vacio.",
        icono: "informacion",
      });
      setTab(3);
      txtDepresiacionMensual.current.focus();
      valido = false;
    } else if (!formato(txtDepresiacionMensual.current.value)) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto de la Depresiación Mensual Inválido",
        icono: "informacion",
      });
      setTab(3);
      txtDepresiacionMensual.current.focus();
      valido = false;
    } else if (txtDepresiacionAcumulada.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto de la Depresiación Acumulada No Puede Estar Vacio.",
        icono: "informacion",
      });
      setTab(3);
      txtDepresiacionAcumulada.current.focus();
      valido = false;
    } else if (!formato(txtDepresiacionAcumulada.current.value)) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto de la Depresiación Acumulada Inválido",
        icono: "informacion",
      });
      setTab(3);
      txtDepresiacionAcumulada.current.focus();
      valido = false;
    } else if (txtValorLibros.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Libros No Puede Estar Vacio.",
        icono: "informacion",
      });
      setTab(3);
      txtValorLibros.current.focus();
      valido = false;
    } else if (!formato(txtValorLibros.current.value)) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Libros Inválido",
        icono: "informacion",
      });
      setTab(3);
      txtValorLibros.current.focus();
      valido = false;
    } else if (txtValorAdicion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Adición No Puede Estar Vacio.",
        icono: "informacion",
      });
      setTab(3);
      txtValorAdicion.current.focus();
      valido = false;
    } else if (!formato(txtValorAdicion.current.value)) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Adición Inválido",
        icono: "informacion",
      });
      setTab(3);
      txtValorAdicion.current.focus();
      valido = false;
    } else if (txtValorReexpresado.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Reexpresado No Puede Estar Vacio.",
        icono: "informacion",
      });
      setTab(3);
      txtValorReexpresado.current.focus();
      valido = false;
    } else if (!formato(txtValorReexpresado.current.value)) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Valor Reexpresado Inválido",
        icono: "informacion",
      });
      setTab(3);
      txtValorReexpresado.current.focus();
      valido = false;
    } else if (txtCostoReposicion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Costo Reposición No Puede Estar Vacio.",
        icono: "informacion",
      });
      setTab(3);
      txtCostoReposicion.current.focus();
      valido = false;
    } else if (!formato(txtCostoReposicion.current.value)) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Monto del Costo Reposición Inválido",
        icono: "informacion",
      });
      setTab(3);
      txtCostoReposicion.current.focus();
      valido = false;
    }

    return valido;
  };

  const onChangeValidar = async () => {
    let sigue = ValidarCampos();
    if (sigue) {
      let valId = [];

      valId.push(txtCodActivo.current.value);
      valId.push(
        txtCodOrden.current.value === "" ? "0" : txtCodOrden.current.value,
      );
      valId.push(txtIdUbicacion.current.value);
      valId.push(txtCodMotivo.current.value);
      valId.push(
        txtCodProveedor.current.value === ""
          ? "0"
          : txtCodProveedor.current.value,
      );
      valId.push(
        txtNumFactura.current.value === ""
          ? "null"
          : txtNumFactura.current.value,
      );

      let datres = [];

      datres.push(
        txtCodigoBien.current.value === ""
          ? "null"
          : txtCodigoBien.current.value.trim().toUpperCase(),
      );
      datres.push(
        moment.utc(txtFechaAdquisicion.current.value).format("YYYY-MM-DD"),
      );
      datres.push(
        txtCodigoBienNacional.current.value === ""
          ? "null"
          : txtCodigoBienNacional.current.value.trim().toUpperCase(),
      );

      const datos = {
        operacion: operacion,
        nid: txtCodigo.current.value === "" ? 0 : txtCodigo.current.value,
        valorid: JSON.stringify(valId),
        vidautiliori:
          txtOriginal.current.value === ""
            ? 0
            : parseInt(txtOriginal.current.value),
        nvidautilmas:
          txtMas.current.value === "" ? 0 : parseInt(txtMas.current.value),
        nvidautilmenos:
          txtMenos.current.value === "" ? 0 : parseInt(txtMenos.current.value),
        cmarca: txtMarca.current.value.toUpperCase(),
        cmodelo: txtModelo.current.value.toUpperCase(),
        nanio:
          txtAnio.current.value === "" ? 0 : parseInt(txtAnio.current.value),
        ccolor: txtColor.current.value.toUpperCase(),
        ncapacidad: parseFloat(
          txtCapacidad.current.value.replace(/\./g, "").replace(",", "."),
        ),
        ctipo: txtTipo.current.value.toUpperCase(),
        cseriales: txtTipo.current.value.toUpperCase(),
        nnumpiezas: parseFloat(
          txtNumPieza.current.value.replace(/\./g, "").replace(",", "."),
        ),
        cplaca: txtTipo.current.value.toUpperCase(),
        nalto: parseFloat(
          txtAlto.current.value.replace(/\./g, "").replace(",", "."),
        ),
        cuso: txtUso.current.value.toUpperCase(),
        nlargo: parseFloat(
          txtLargo.current.value.replace(/\./g, "").replace(",", "."),
        ),
        nancho: parseFloat(
          txtAncho.current.value.replace(/\./g, "").replace(",", "."),
        ),
        observacion:
          txtObservacion.current.value.trim().toString().length > 700
            ? txtObservacion.current.value
                .trim()
                .substring(0, 699)
                .toUpperCase()
            : txtObservacion.current.value.trim().toUpperCase(),
        nvalorinicial: parseFloat(
          txtValorInicial.current.value.replace(/\./g, "").replace(",", "."),
        ),
        nvalorrescate: parseFloat(
          txtValorRescate.current.value.replace(/\./g, "").replace(",", "."),
        ),
        depremensual: parseFloat(
          txtDepresiacionMensual.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        ),
        depreacumulada: parseFloat(
          txtDepresiacionAcumulada.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        ),
        nvalorlibros: parseFloat(
          txtValorLibros.current.value.replace(/\./g, "").replace(",", "."),
        ),
        nvaloradicion: parseFloat(
          txtValorAdicion.current.value.replace(/\./g, "").replace(",", "."),
        ),
        valorreexpre: parseFloat(
          txtValorReexpresado.current.value
            .replace(/\./g, "")
            .replace(",", "."),
        ),
        costorepo: parseFloat(
          txtCostoReposicion.current.value.replace(/\./g, "").replace(",", "."),
        ),
        fecincor: moment.utc(txtFecha.current.value).format("YYYY-MM-DD"),
        cdatres: JSON.stringify(datres),
        tipmat: txtTipoMaterial.current.value,
      };

      await procesarRegistro({
        datos: datos,
      });
    }
  };

  const seleccionarRegistro = async () => {
    const campos = "*";
    const id = txtCodigo.current.value;
    const nomtab = "incorporacionmueble";
    const nomid = "idincorporacionmueble";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            if (data.statusbien === 1) {
              txtCodigo.current.value = "";
              btnTab1.current.disabled = false;
              btnTab2.current.disabled = true;
              btnTab3.current.disabled = true;
              blanquear();
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Bien Mueble fue Desincorporado",
                icono: "informacion",
              });
            } else {
              btnTab1.current.disabled = false;
              btnTab2.current.disabled = false;
              btnTab3.current.disabled = false;

              txtCodigo.current.disabled = true;

              txtCodActivo.current.value = data.idtipoactivo;
              if (op.espiritu === 7) {
                txtTipoMaterial.current.value =
                  data.tipomaterial === null ? "" : data.tipomaterial;
              }
              txtCodOrden.current.value =
                data.idordenpago == 0 ? "" : data.idordenpago;
              txtNumFactura.current.value =
                data.numfactura == null ? "" : data.numfactura.trim();
              txtCodProveedor.current.value =
                data.idproveedor == 0 ? "" : data.idproveedor;
              txtIdUbicacion.current.value = data.idubicacionbien;
              txtOriginal.current.value = data.vidautiloriginal;
              txtMas.current.value = data.vidautilmas;
              txtMenos.current.value = data.vidautilmenos;
              txtCodigoBien.current.value =
                data.codigobien == null ? "" : data.codigobien.trim();
              txtCodigoBienNacional.current.value =
                data.codigobiennacional == null
                  ? ""
                  : data.codigobiennacional.trim();

              txtMarca.current.value = data.marca === null ? "" : data.marca;
              txtModelo.current.value = data.modelo === null ? "" : data.modelo;
              txtAnio.current.value == data.anio;
              txtColor.current.value = data.color === null ? "" : data.color;
              txtCapacidad.current.value = data.capacidad;
              txtTipo.current.value = data.tipo === null ? "" : data.tipo;
              txtSeriales.current.value =
                data.seriales === null ? "" : data.seriales;
              txtNumPieza.current.value = data.numpiezas;
              txtPlaca.current.value = data.placa === null ? "" : data.placa;
              txtAlto.current.value = data.alto;
              txtLargo.current.value = data.largo;
              txtAncho.current.value = data.ancho;
              txtUso.current.value = data.uso === null ? "" : data.uso;
              txtObservacion.current.value =
                data.observacionincorporacion == null
                  ? ""
                  : data.observacionincorporacion.trim();

              txtCodMotivo.current.value = data.idmotivoincorporacion;
              txtValorInicial.current.value = formatMoneda(
                data.valorinicial.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtValorRescate.current.value = formatMoneda(
                data.valorrescate.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtDepresiacionMensual.current.value = formatMoneda(
                data.depresiacionmensual.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtDepresiacionAcumulada.current.value = formatMoneda(
                data.depresiacionacumulada.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtValorLibros.current.value = formatMoneda(
                data.valorlibros.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtValorAdicion.current.value = formatMoneda(
                data.valoradicion.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtValorReexpresado.current.value = formatMoneda(
                data.valorreexpresado.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtCostoReposicion.current.value = formatMoneda(
                data.costoreposicion.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtFecha.current.value = moment
                .utc(data.fechaincorporacion)
                .format("YYYY-MM-DD");
              txtFechaAdquisicion.current.value = moment
                .utc(data.fechaadquisicion)
                .format("YYYY-MM-DD");

              if (data.idtipoactivo !== 0 && data.idtipoactivo !== null) {
                await seleccionarRegistroTipoActivo();
              }

              if (data.idordenpago !== 0 && data.idordenpago !== null) {
                await seleccionarOrdenPago();
              }

              if (data.idproveedor !== 0 && data.idproveedor !== null) {
                await seleccionarRegistroProveedor();
              }

              if (data.idubicacionbien !== 0 && data.idubicacionbien !== null) {
                await seleccionarRegistroUbicacion();
              }

              if (
                data.idmotivoincorporacion !== 0 &&
                data.idmotivoincorporacion !== null
              ) {
                await seleccionarRegistroMotivo();
              }

              setDisabledCode(true);

              if (data.idasiento) {
                setIdAsiAnt(data.idasiento);
              } else {
                setIdAsiAnt(0);
              }

              if (operacion === 2) {
                habilitarCampos();
              }

              if (operacion === 4) {
                setDisabledPrint(false);
              } else {
                setDisabledPrint(true);
              }
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Bien Mueble no existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarRegistroProveedor = async () => {
    const campos = "*";
    const id = txtCodProveedor.current.value;
    const nomtab = "proveedor";
    const nomid = "idproveedor";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;

            txtRif.current.value = data.rif;
            txtNombre.current.value = data.razonsocial;
          } else {
            txtCodProveedor.current.value = "";
            txtRif.current.value = "";
            txtNombre.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Proveedor no Existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarRegistroTipoActivo = async () => {
    const campos = "*";
    const id = txtCodActivo.current.value;
    const nomtab = "tipoactivo";
    const nomid = "idtipoactivo";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;

            if (data.tipobien === 1) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El el tipo de activo no es mueble",
                icono: "informacion",
              });
              txtCodActivo.current.value = "";
              txtCodActivo.current.focus();
              setIdClaseBien(0);
            } else {
              txtDescripcionActivo.current.value = data.descripcion;
              txtTipoMaterial.current.value =
                data.tipomaterial === null ? "" : data.tipomaterial;
              setIdClaseBien(data.idclasificabienes);
            }
          } else {
            txtCodActivo.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Tipo Activo no Existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarRegistroUbicacion = async () => {
    const campos = "u.*, (p.apellidos || ' ' || p.nombres) As nombre ";
    const id = txtIdUbicacion.current.value;
    const nomtab = "ubicacionbien u, persona p";
    const nomid = "idubicacionbien";
    const condic =
      " u.cedularesponsable = p.cedula AND ubicacionfisica = true ";

    const endpoint = `${op.conexion}/api/consulta/modelicondi?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&condic=${condic}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            const data = response.data[0];

            const cod =
              data.codigoubicacion.substring(0, 2) +
              "-" +
              data.codigoubicacion.substring(2, 4) +
              "-" +
              data.codigoubicacion.substring(4, 6) +
              "-" +
              data.codigoubicacion.substring(6, 8);

            txtCodigoUbicacion.current.value = cod;
            txtDescripcionUbicacion.current.value =
              data.descripcionubicacionbien;
            txtCedula.current.value = data.cedularesponsable;
            txtNombreResponsa.current.value = data.nombre;
          } else {
            txtIdUbicacion.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "La ubicacion no Existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarRegistroMotivo = async () => {
    const campos = "*";
    const id = txtCodMotivo.current.value;
    const nomtab = "motivoincorporacion";
    const nomid = "idmotivoincorporacion";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtDescripcionMotivo.current.value =
              data.descripcionincorporacion.trim();
            setGeneraAsiento(data.afectaconta);
          } else {
            txtCodMotivo.current.value = "";
            txtDescripcionMotivo.current.value = "";
            setGeneraAsiento(false);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Motivo de Incorporación no Existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarOrdenPago = async () => {
    const id = txtCodOrden.current.value;
    const endpoint = `${op.conexion}/api/bienes/incorporacionmueble/seleccionar_ordenpago?&idordenpago=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;

            if (data.reversado === 1) {
              txtCodOrden.current.focus();
              txtCodOrden.current.value = "";

              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "La orden de pago fue reversada",
                icono: "informacion",
              });
            } else {
              if (data.numfactura) {
                txtNumFactura.current.value = data.numfactura;
              } else {
                txtNumFactura.current.value = "";
              }

              txtCodProveedor.current.value = data.idproveedor;
            }
          } else {
            txtNumFactura.current.focus();
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const validarCodigo = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodigo.current.blur();
        seleccionarRegistro();
      }
    }
  };

  const validarCodigoActivo = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodActivo.current.blur();
        seleccionarRegistroTipoActivo();
      } else {
        txtCodActivo.current.value = "";
        txtDescripcionActivo.current.value = "";
        txtTipoMaterial.current.value = "";
      }
    }
  };

  const validarCodigoOrdenPago = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodOrden.current.blur();
        seleccionarOrdenPago();
      } else {
        txtCodOrden.current.value = "";
        txtNumFactura.current.value = "";
      }
    }
  };

  const validarCodigoProveedor = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodProveedor.current.blur();
        seleccionarRegistroProveedor();
      } else {
        txtCodProveedor.current.value = "";
        txtRif.current.value = "";
        txtNombre.current.value = "";
      }
    }
  };

  const validarCodigoUbicacion = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtIdUbicacion.current.blur();
        txtCodigoUbicacion.current.value = "";
        txtDescripcionUbicacion.current.value = "";
        txtCedula.current.value = "";
        txtNombreResponsa.current.value = "";
        seleccionarRegistroUbicacion();
      } else {
        txtIdUbicacion.current.value = "";
        txtCodigoUbicacion.current.value = "";
        txtDescripcionUbicacion.current.value = "";
        txtCedula.current.value = "";
        txtNombreResponsa.current.value = "";
      }
    }
  };

  const validarCodigoMotivo = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodMotivo.current.blur();
        seleccionarRegistroMotivo();
      } else {
        txtCodMotivo.current.value = "";
        txtDescripcionMotivo.current.value = "";
      }
    }
  };

  const onHideCatalogoTipo = (value = false) => {
    setMostrarCatalogoTipo(false);
    if (value) {
      txtCodActivo.current.value = value.idtipoactivo;
      seleccionarRegistroTipoActivo();
    }
  };

  const onHideCatalogoOrden = (value = false) => {
    setMostrarCatalogoOrden(false);
    if (value) {
      txtCodOrden.current.value = value.numordenpago;
      seleccionarOrdenPago();
    }
  };

  const onHideCatalogoProveedor = (value = false) => {
    setMostrarCatalogoProveedor(false);
    if (value) {
      txtCodProveedor.current.value = value.idproveedor;
      seleccionarRegistroProveedor();
    }
  };

  const onHideCatalogoUbicacion = (value = false) => {
    setMostrarCatalogoUbicacion(false);
    if (value) {
      txtIdUbicacion.current.value = value;
      seleccionarRegistroUbicacion();
    }
  };

  const onHideCatalogoMotivo = (value = false) => {
    setMostrarCatalogoMotivo(false);
    if (value) {
      txtCodMotivo.current.value = value.idmotivoincorporacion;
      seleccionarRegistroMotivo();
    }
  };

  const onHideCatalogoIncorp = (value = false) => {
    setMostrarCatalogoIncorp(false);
    if (value) {
      txtCodigo.current.value = value.idincorporacionmueble;
      seleccionarRegistro();
    }
  };

  const imprimirIncorporacionBienMueble = () => {
    const reporte = "ListIncorporacion";
    const dolar = 0.0;
    const bolivar = 0.0;
    const sql = "'" + txtCodigo.current.value + "'";
    const sql2 = dolar.toString();
    const sql3 = bolivar.toString();
    const titulo = "INCORPORACION DE BIENES NACIONALES";

    window.open(
      op.reportes +
        "/bienes?" +
        "reporte=" +
        reporte +
        "&ID=" +
        sql +
        "&DOLAR=" +
        sql2 +
        "&BOLIVAR=" +
        sql3 +
        "&TITULO=" +
        titulo,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const onClickButton = async (value) => {
    if (value === 1) {
      setTab(1);
      setOperacion(1);
      setTxtOperacion("[Incluyendo]");
      setVisibleButton(false);
      setDisabledCode(true);
      habilitarCampos();
      txtFecha.current.value = moment.utc(fechasistema).format("YYYY-MM-DD");
      txtFechaAdquisicion.current.value = moment
        .utc(fechasistema)
        .format("YYYY-MM-DD");
      btnTab1.current.disabled = false;
      btnTab2.current.disabled = false;
      btnTab3.current.disabled = false;
      setTimeout(() => {
        txtCodActivo.current.focus();
      }, 200);
    } else if (value === 2) {
      setTab(1);
      setOperacion(2);
      setTxtOperacion("[Editando]");
      setVisibleButton(false);
      setDisabledCode(false);
      btnTab1.current.disabled = false;
      btnTab2.current.disabled = true;
      btnTab3.current.disabled = true;
      setTimeout(() => {
        txtCodigo.current.focus();
      }, 200);
    } else if (value === 3) {
      setTab(1);
      setOperacion(3);
      setTxtOperacion("[Eliminando]");
      setVisibleButton(false);
      setDisabledCode(false);
      btnTab1.current.disabled = false;
      btnTab2.current.disabled = true;
      btnTab3.current.disabled = true;
      setTimeout(() => {
        txtCodigo.current.focus();
      }, 200);
    } else if (value === 4) {
      setTab(1);
      setOperacion(4);
      setTxtOperacion("[Consultando]");
      setVisibleButton(false);
      setDisabledCode(false);
      btnTab1.current.disabled = false;
      btnTab2.current.disabled = true;
      btnTab3.current.disabled = true;
      setTimeout(() => {
        txtCodigo.current.focus();
      }, 200);
    } else if (value === 5) {
      setVisibleButton(false);
      await onChangeValidar();
    } else if (value === 6) {
      blanquear();
      deshabilitarCampos();
    } else if (value === 7) {
      imprimirIncorporacionBienMueble();
    }
  };

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="xl" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">
          Incorporación Bienes Muebles {txtOperacion}
        </h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body
        style={{
          height: 480,
        }}
      >
        <ul
          className="nav d-flex flex-wrap gap-1 align-items-center"
          id="ex-with-icons"
          role="tablist"
        >
          <li
            className="nav-item"
            onClick={() => setTab(1)}
            role="presentation"
          >
            <button
              className="nav-link text-white rounded p-2 bg-primary"
              style={tab === 1 ? estilos.tab : {}}
              ref={btnTab1}
              disabled
            >
              <i className="fas mx-2 fa-folder-minus"></i>Datos Generales
            </button>
          </li>
          <li
            className="nav-item"
            onClick={() => setTab(2)}
            role="presentation"
          >
            <button
              className="nav-link text-white rounded p-2 bg-primary"
              style={tab === 2 ? estilos.tab : {}}
              ref={btnTab2}
              disabled
            >
              {" "}
              <i className="fas mx-2 fa-money-bill"></i> Características del
              Inmueble
            </button>
          </li>

          <li
            className="nav-item"
            onClick={() => setTab(3)}
            role="presentation"
          >
            <button
              className="nav-link text-white rounded p-2 bg-primary"
              style={tab === 3 ? estilos.tab : {}}
              ref={btnTab3}
              disabled
            >
              {" "}
              <i className="fas mx-2 fa-money-bill"></i> Costos
            </button>
          </li>
        </ul>

        <div className="tab-content mt-2" id="nav-tabContent">
          <div hidden={tab !== 1}>
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-2 m-0 mb-2 p-0">
                <SearchInput
                  ref={txtCodigo}
                  disabled={disabledCode}
                  onKeyUp={validarCodigo}
                  onBlur={validarCodigo}
                  label="Id Sistema:"
                  name="codigo"
                  autoComplete="off"
                  disabledButton={disabledCode}
                  onClickButton={() => setMostrarCatalogoIncorp(true)}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <SearchInput
                  ref={txtCodActivo}
                  disabled={
                    operacion === 0 || operacion === 3 || operacion === 4
                  }
                  onKeyUp={validarCodigoActivo}
                  onBlur={validarCodigoActivo}
                  label="Id. Tipo Activo:"
                  name="codactivo"
                  autoComplete="off"
                  disabledButton={
                    operacion === 0 || operacion === 3 || operacion === 4
                  }
                  onClickButton={() => setMostrarCatalogoTipo(true)}
                />
              </div>
              <div className="col-7 m-0 mb-2 p-0 pl-2">
                <Textarea
                  ref={txtDescripcionActivo}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                  label="Descripción:"
                  name="descripcion"
                />
              </div>
              <div className="col-9 m-0 p-0">
                <Input
                  label="Tipo Material:"
                  name="tipomaterial"
                  ref={txtTipoMaterial}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Fecha Incorporación:"
                  name="fecha"
                  type="date"
                  ref={txtFecha}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                  autoComplete="off"
                />
              </div>
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos Orden Pago
                </legend>
                <div className="col-3 m-0 mb-2 p-0">
                  <SearchInput
                    ref={txtCodOrden}
                    disabled={
                      operacion === 0 || operacion === 3 || operacion === 4
                    }
                    onKeyUp={validarCodigoOrdenPago}
                    onBlur={validarCodigoOrdenPago}
                    label="Cod. Orden Pago:"
                    name="codordenpago"
                    autoComplete="off"
                    disabledButton={
                      operacion === 0 || operacion === 3 || operacion === 4
                    }
                    onClickButton={() => setMostrarCatalogoOrden(true)}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Factura:"
                    name="numfactura"
                    autoComplete="off"
                    ref={txtNumFactura}
                    disabled
                    onChange={onChange}
                    onKeyUp={onNextChange}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Fecha Adquisición:"
                    name="fechaadquisicion"
                    type="date"
                    autoComplete="off"
                    ref={txtFechaAdquisicion}
                    disabled
                    onChange={onChange}
                    onKeyUp={onNextChange}
                  />
                </div>
                <div className="col-12 m-0 p-0 d-flex flex-wrap">
                  <div className="col-3 m-0 p-0">
                    <SearchInput
                      ref={txtCodProveedor}
                      disabled={
                        operacion === 0 || operacion === 3 || operacion === 4
                      }
                      onKeyUp={validarCodigoProveedor}
                      onBlur={validarCodigoProveedor}
                      label="Cod. Proveedor:"
                      name="codproveedor"
                      autoComplete="off"
                      disabledButton={
                        operacion === 0 || operacion === 3 || operacion === 4
                      }
                      onClickButton={() => setMostrarCatalogoProveedor(true)}
                    />
                  </div>
                  <div className="col-3 m-0 p-0 pl-2">
                    <Input
                      label="C.I. / RIF:"
                      name="cedula"
                      ref={txtRif}
                      disabled
                      onChange={onChange}
                      onKeyUp={onNextChange}
                    />
                  </div>
                  <div className="col-6 m-0 p-0 pl-2">
                    <Input
                      label="Nombre / Razón Social:"
                      name="nombre"
                      ref={txtNombre}
                      disabled
                      onChange={onChange}
                      onKeyUp={onNextChange}
                    />
                  </div>
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos de la Ubicación
                </legend>
                <div className="col-2 m-0 p-0">
                  <SearchInput
                    ref={txtIdUbicacion}
                    disabled={
                      operacion === 0 || operacion === 3 || operacion === 4
                    }
                    onKeyUp={validarCodigoUbicacion}
                    onBlur={validarCodigoUbicacion}
                    label="Id. Ubicación:"
                    name="codubicacion"
                    autoComplete="off"
                    disabledButton={
                      operacion === 0 || operacion === 3 || operacion === 4
                    }
                    onClickButton={() => setMostrarCatalogoUbicacion(true)}
                  />
                </div>
                <div className="col-4 m-0 p-0 pl-2">
                  <Input
                    label="Código:"
                    name="descripcion"
                    ref={txtCodigoUbicacion}
                    disabled
                    onChange={onChange}
                    onKeyUp={onNextChange}
                  />
                </div>
                <div className="col-6 m-0 p-0 pl-2">
                  <Input
                    label="Dirección:"
                    name="direccion"
                    ref={txtDescripcionUbicacion}
                    disabled
                    onChange={onChange}
                    onKeyUp={onNextChange}
                  />
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos Vida Útil
                </legend>
                <div className="col-3 m-0 p-0">
                  <Input
                    label="Original:"
                    name="original"
                    ref={txtOriginal}
                    disabled
                    defaultValue={0}
                    onFocus={seleccionarCampo}
                    onKeyUp={calcularVidaUtil}
                    onBlur={calcularVidaUtil}
                    inputClassName="text-end"
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input
                    label="+"
                    name="mas"
                    ref={txtMas}
                    disabled
                    defaultValue={0}
                    onFocus={seleccionarCampo}
                    onKeyUp={calcularVidaUtil}
                    onBlur={calcularVidaUtil}
                    inputClassName="text-end"
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input
                    label="-"
                    name="menos"
                    ref={txtMenos}
                    disabled
                    defaultValue={0}
                    onFocus={seleccionarCampo}
                    onKeyUp={calcularVidaUtil}
                    onBlur={calcularVidaUtil}
                    inputClassName="text-end"
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input
                    label="Actual:"
                    name="actual"
                    inputClassName="text-end"
                    ref={txtActual}
                    disabled
                    defaultValue={0}
                  />
                </div>
              </fieldset>
            </div>
          </div>
          <div hidden={tab !== 2}>
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Mueble
              </legend>
              <div className="col-6 m-0 mb-2 p-0">
                <Input
                  label="Código del Bien:"
                  name="codigobien"
                  autoComplete="off"
                  ref={txtCodigoBien}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Código Bienes Nacionales:"
                  name="codigobiennacional"
                  autoComplete="off"
                  ref={txtCodigoBienNacional}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-5 m-0 mb-2 p-0">
                <Input
                  label="Marca:"
                  name="marca"
                  autoComplete="off"
                  ref={txtMarca}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-5 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Modelo:"
                  name="modelo"
                  autoComplete="off"
                  ref={txtModelo}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Año:"
                  name="anio"
                  autoComplete="off"
                  ref={txtAnio}
                  defaultValue={0}
                  disabled
                  onFocus={seleccionarCampo}
                  onChange={validaSoloNumero}
                  inputClassName="text-end"
                />
              </div>
              <div className="col-5 m-0 mb-2 p-0">
                <Input
                  label="Color:"
                  name="color"
                  autoComplete="off"
                  ref={txtColor}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Capacidad:"
                  name="capacidad"
                  autoComplete="off"
                  ref={txtCapacidad}
                  disabled
                  defaultValue={0}
                  onFocus={seleccionarCampo}
                  onChange={validaSoloNumero}
                  inputClassName="text-end"
                />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Tipo:"
                  name="tipo"
                  autoComplete="off"
                  ref={txtTipo}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-5 m-0 mb-2 p-0">
                <Input
                  label="Seriales:"
                  name="seriales"
                  autoComplete="off"
                  ref={txtSeriales}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Numero de Piezas:"
                  name="numpieza"
                  autoComplete="off"
                  ref={txtNumPieza}
                  disabled
                  defaultValue={0}
                  onFocus={seleccionarCampo}
                  onChange={validaSoloNumero}
                  inputClassName="text-end"
                />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Placa:"
                  name="placa"
                  autoComplete="off"
                  ref={txtPlaca}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-6 m-0 p-0">
                <Input
                  label="Uso:"
                  name="uso"
                  autoComplete="off"
                  ref={txtUso}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input
                  label="Alto:"
                  name="alto"
                  autoComplete="off"
                  ref={txtAlto}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input
                  label="Largo:"
                  name="largo"
                  autoComplete="off"
                  ref={txtLargo}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input
                  label="Ancho:"
                  name="ancho"
                  autoComplete="off"
                  ref={txtAncho}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
                <legend className="float-none w-auto m-0">Disposición</legend>
                <div className="col-3 m-0 p-0">
                  <SearchInput
                    ref={txtCodMotivo}
                    disabled={
                      operacion === 0 || operacion === 3 || operacion === 4
                    }
                    onKeyUp={validarCodigoMotivo}
                    onBlur={validarCodigoMotivo}
                    label="Cod. Motivo:"
                    name="codmotivo"
                    autoComplete="off"
                    disabledButton={
                      operacion === 0 || operacion === 3 || operacion === 4
                    }
                    onClickButton={() => setMostrarCatalogoMotivo(true)}
                  />
                </div>
                <Input
                  label="Descripción:"
                  name="descripcion"
                  autoComplete="off"
                  disabled
                  ref={txtDescripcionMotivo}
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </fieldset>

              <div className="col-12 m-0 my-2 p-0">
                <Textarea
                  label="Observación:"
                  name="observacion"
                  autoComplete="off"
                  ref={txtObservacion}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                  style={{ height: 70 }}
                />
              </div>
            </fieldset>
            <fieldset className="col-12 m-0 p-2 d-flex gap-2  border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Responsable Patrimonial
              </legend>
              <div className="col-3 m-0 p-0">
                <Input
                  label=" Cédula de Identidad:"
                  name="cedula"
                  ref={txtCedula}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <Input
                label="Nombre del Responsable:"
                name="nombre_responsable"
                ref={txtNombreResponsa}
                disabled
                onChange={onChange}
                onKeyUp={onNextChange}
              />
            </fieldset>
          </div>
          <div hidden={tab !== 3}>
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-3 m-0 mb-2 p-0">
                <Input
                  label="Valor Inicial:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_inicial"
                  ref={txtValorInicial}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Valor Rescate:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_rescate"
                  ref={txtValorRescate}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Depressiación Mensual:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="depresacion_mensual"
                  ref={txtDepresiacionMensual}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Depresiación Acumulada:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="depresiacion_acumulada"
                  ref={txtDepresiacionAcumulada}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 p-0">
                <Input
                  label="Valor Libros:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_inicial"
                  ref={txtValorLibros}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Valor Adición:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_adicion"
                  ref={txtValorAdicion}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Valor Reexpresado:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_reepresado"
                  ref={txtValorReexpresado}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Costo Reposición:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="costo_reposicion"
                  ref={txtCostoReposicion}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {visibleButton ? (
          <div className="col-12 d-flex m-auto justify-content-between">
            <SuccessButton onClick={() => onClickButton(1)} icon="fas fa-plus">
              Incluir
            </SuccessButton>
            <InfoButton onClick={() => onClickButton(4)} icon="fas fa-search">
              Consultar
            </InfoButton>
            <WarningButton onClick={() => onClickButton(2)} icon="fas fa-edit">
              Editar
            </WarningButton>
            <DangerButton onClick={() => onClickButton(3)} icon="fas fa-trash">
              Eliminar
            </DangerButton>
          </div>
        ) : (
          <div className="col-12 d-flex m-auto justify-content-end">
            <div className="m-1 p-0">
              <InfoButton
                icon="fas fa-print"
                disabled={disabledPrint}
                onClick={() => onClickButton(7)}
              >
                Imprimir
              </InfoButton>
            </div>
            <div className="m-1 p-0">
              <SuccessButton
                disabled={operacion === 4}
                ref={btnAcepta}
                onClick={() => onClickButton(5)}
              >
                Aceptar
              </SuccessButton>
            </div>
            <div className="m-1 p-0">
              <DangerButton ref={btnCancela} onClick={() => onClickButton(6)}>
                Cancelar
              </DangerButton>
            </div>
          </div>
        )}
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <CatalogoTipoActivos
        show={mostrarCatalogoTipo}
        onHide={onHideCatalogoTipo}
      />

      <CatalogoOrdenPago
        show={mostrarCatalogoOrden}
        onHide={onHideCatalogoOrden}
      />

      <CatalogoProveedores
        show={mostrarCatalogoProveedor}
        tip={2}
        onHide={onHideCatalogoProveedor}
      />

      <CatalogoUbicacionBien
        show={mostrarCatalogoUbicacion}
        onHideCancelar={() => setMostrarCatalogoUbicacion(false)}
        onHideAceptaCatalogo={onHideCatalogoUbicacion}
      />

      <CatalogoMotivoIncorporacion
        show={mostrarCatalogoMotivo}
        onHide={onHideCatalogoMotivo}
      />

      <CatalogoIncorporacionMueble
        show={mostrarCatalogoIncorp}
        onHide={onHideCatalogoIncorp}
      />
    </Modal>
  );
}
